export default __webpack_public_path__ + "static/utas_logo_white-78b3e0a68236665333ab772a4bbc0208.svg";